export const customQueryOptions = <T>(options: T): T => {
  return {
    staleTime: 1000 * 60 * 5, // 5 minutes
    ...options,
  };
};
